import React from 'react';
import UiKitButton from 'components/UiKit/Button';
import PropTypes from 'prop-types';

const EditFooterButtons = ({ onSave, onSaveAndCreateNew }) => {
  return (
    <div className="flex gap-4 py-3 px-6 justify-end w-full border-neutral-20 border-t">
      <UiKitButton variant="outline" onClick={onSave}>
        Save Changes
      </UiKitButton>
      <UiKitButton ghost variant="primary" onClick={onSaveAndCreateNew}>
        Save Changes & Create New
      </UiKitButton>
    </div>
  );
};

EditFooterButtons.propTypes = {
  onSave: PropTypes.func.isRequired,
  onSaveAndCreateNew: PropTypes.func.isRequired
};

export default EditFooterButtons;
